export default "__VITE_ASSET__BPsGjhiO__"